module.exports = __webpack_public_path__ + "static/media/element.036cd76e.svg";